<template>
    <div>
        <alert ref="alert"></alert>

        <modal ref="modal" :disable-close="true">
            <div class="flex text-left w-full h-full bg-purple-900 items-center justify-center p-10 flex-col overflow-y-auto">
                <h1>Por favor, complete seu cadastro para continuar</h1>
                <p class="text-left w-full mt-2">
                    Todos os dados são sigilosos e não serão compartilhados.
                </p>

                <div class="w-full flex flex-col mt-10 gap-2">
                    <div class="flex flex-col gap-2">
                        <div>
                            <label for="cpf" class="font-bold">CPF</label>
                        </div>
                        <div class="flex">
                            <input type="text"
                                   id="cpf"
                                   placeholder="___.___.___-__"
                                   v-model="cpf"
                                   v-maska
                                   data-maska="###.###.###-##"
                                   class="input mr-5">
                        </div>
                    </div>

                    <div class="my-3 py-3">
                        <hr>
                    </div>

                    <div class="flex flex-col gap-2">
                        <div>
                            <label for="cpf" class="font-bold">CEP</label>
                        </div>

                        <div class="flex">
                            <input type="text" id="cep" class="input mr-5"
                                   placeholder="_____-___"
                                   v-model="address.cep"
                                   @keyup="checkCEP()"
                                   @blur="checkCEP()"
                                   v-maska
                                   data-maska="#####-###">
                        </div>
                    </div>

                    <div class="flex flex-row gap-2 mt-2" v-if="address.completed">
                        <div class="w-1/2 flex-col">
                            <label for="cpf" class="font-bold">Endereço</label>

                            <div>
                                {{ address.street }} <br>
                                {{ address.city }} / {{ address.state }}
                            </div>
                        </div>

                        <div class="flex flex-col pl-5 w-1/2">
                            <div class="flex flex-col ml-2">
                                <div>
                                    <label for="cpf" class="font-bold">Número da Residência</label>
                                </div>
                                <input type="text" name="address_number" maxlength="10" class="input" v-model="address.number">
                            </div>
                        </div>
                    </div>

                    <div class="w-full mt-10">
                        <button class="btn btn-orange"
                                @click="update()"
                                :disabled="loading">
                            Finalizar
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import {Zapin} from "@/services/Api";

    export default {

        data() {
            return {
                cpf: null,
                loading: false,
                address: {
                    completed: false,
                    cep: null,
                    number: null,
                    street: null,
                    city: null,
                    state: null
                }
            }
        },

        mounted() {
            this.$refs.modal.open();
        },

        methods: {
            update() {
                if(this.address.completed) {
                    this.loading = true;

                    Zapin
                        .account()
                        .updateAddress({
                            cpf: this.cpf,
                            cep: this.address.cep,
                            number: this.address.number
                        })
                        .then(() => {

                            Zapin
                                .updateUserData()
                                .then(() => {
                                    this.$router.push({
                                        name: 'Dashboard'
                                    });
                                });
                        })
                        .catch(err => {
                            if(err.status === 422) {
                                this.$refs.alert.showValidationErrors(err.data);
                            } else {
                                this.$refs.alert.show(this.$t('unknown_error_try_again'));
                            }
                        })
                        .finally(() => this.loading = false);
                }
            },

            checkCEP() {
                if(this.address.cep && this.address.cep.length >= 9) {
                    this.loading = true;

                    Zapin
                        .account()
                        .checkCEP(this.address.cep)
                        .then(info => {
                            this.address.completed = true;
                            this.address.street = info.data.street;
                            this.address.city = info.data.city;
                            this.address.state = info.data.state;
                        })
                        .catch(err => {
                            this.address.completed = false;

                            if(err.status === 422) {
                                this.$refs.alert.showValidationErrors(err.data);
                            } else {
                                this.$refs.alert.show(this.$t('unknown_error_try_again'));
                            }
                        })
                        .finally(() => this.loading = false)
                }
            }
        }

    }
</script>